import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ReviewExemptionArgs {
  @Field(t => Int)
  claimId!: number

  @Field(t => [Int], { nullable: true })
  grantSites?: number[]

  @Field(t => [Int], { nullable: true })
  revokeSites?: number[]
}
